import type { MarketsApi } from "@/v2/api/metadata/markets";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { marketsConfigurationSaveRef } from "./configuration/save-ref";

async function save(_ctx: DialogTabSaveContext): Promise<void> {
  if (!marketsConfigurationSaveRef.value) return;
  await marketsConfigurationSaveRef.value();
}

export function createConfigurationTab(options: { marketsApi: MarketsApi }): ContentTab {
  return {
    id: "configuration",
    label: "Configurations",
    save,
    children: [
      {
        type: "component",
        component: () => import("./configuration/MarketConfigurationFields.vue"),
        props: { marketsApi: options.marketsApi },
      },
    ],
  };
}
